import React from "react";

function Update() {
  return (
    <p className="update">Última atualização em: 19/11/2024</p>
  );
}

export default Update;
